import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { readErrorCode, readErrorMessage } from "../utils/errorHandler";
var NO_CODE_MESSAGES = {};
export var useListErrorMessage = function (error, codeMessageIds) {
    if (codeMessageIds === void 0) { codeMessageIds = NO_CODE_MESSAGES; }
    var formatMessage = useIntl().formatMessage;
    var _a = useState(null), serverError = _a[0], setServerError = _a[1];
    useEffect(function () {
        if (!error) {
            return undefined;
        }
        var active = true;
        Promise.all([readErrorCode(error), readErrorMessage(error)]).then(function (_a) {
            var code = _a[0], message = _a[1];
            if (active) {
                setServerError({ error: error, code: code, message: message });
            }
        });
        return function () {
            active = false;
        };
    }, [error]);
    if (!error) {
        return undefined;
    }
    var generic = formatMessage({
        id: "ui-br-legaldeposits.error.loading.data",
    });
    var current = (serverError === null || serverError === void 0 ? void 0 : serverError.error) === error ? serverError : null;
    var codeMessageId = (current === null || current === void 0 ? void 0 : current.code)
        ? codeMessageIds[current.code]
        : undefined;
    var detail = codeMessageId
        ? formatMessage({ id: codeMessageId })
        : current === null || current === void 0 ? void 0 : current.message;
    return detail ? "".concat(generic, ": ").concat(detail) : generic;
};
